// extracted by mini-css-extract-plugin
export default {"border":"style_border__fTRL7","square":"style_square__icRiL","round":"style_round__JjAf-","circle":"style_circle__qUE6X"};